import { useCustomT } from '@crimeos-frontend/shared/common'

import { showFailureToastWithGivenMessage } from '../../../utils/ToastUtils'
import { FieldOptionsType } from '../../../types/FieldOptionsTypes'

import { SearchLookupQueryResult as QueryResult } from './query.generatedTypes'

interface UseAPIResponseHandlerReturnType {
  handleAPIResponse: (
    response: QueryResult,
    onSuccess?: () => void
  ) => FieldOptionsType
}

const useAPIResponseHandler = (): UseAPIResponseHandlerReturnType => {
  const commonAPIErrorT = useCustomT('common:apiErrorMessages')
  const recordsCommonAPIErrorT = useCustomT('recordsCommon:apiErrorMessages')

  const searchLookupEmptyData: FieldOptionsType = {
    fieldOptions: [],
    totalCount: 0
  }

  const handleAPIResponse = (
    response: QueryResult,
    onSuccess?: () => void
  ): FieldOptionsType => {
    const hasEmptyResponse = !response || !response.data
    if (hasEmptyResponse) throw new Error('SearchLookup not found')
    if (!response.data?.searchLookup) return searchLookupEmptyData

    const searchLookupResult = response.data.searchLookup

    switch (searchLookupResult.__typename) {
      case 'LookupResponseResult': {
        const lookupFieldsResult = {
          fieldOptions: searchLookupResult.lookupResponses,
          totalCount: searchLookupResult.totalCount
        }
        if (onSuccess) onSuccess()

        return lookupFieldsResult
      }

      case 'InvalidLimit':
        showFailureToastWithGivenMessage(
          searchLookupResult.message || commonAPIErrorT('invalidLimit')
        )
        break

      case 'InvalidOffset': {
        showFailureToastWithGivenMessage(
          searchLookupResult.message || commonAPIErrorT('invalidOffset')
        )
        break
      }

      case 'RecordNotFound':
      case 'RecordAccessDenied': {
        showFailureToastWithGivenMessage(
          searchLookupResult.message ||
            recordsCommonAPIErrorT(searchLookupResult.__typename)
        )
        break
      }

      case 'FieldNotFound':
      case 'FieldIsDeleted':
        showFailureToastWithGivenMessage(
          searchLookupResult.message ||
            recordsCommonAPIErrorT('configurationIsUpdated')
        )
        break

      case 'NotLookupField':
        showFailureToastWithGivenMessage(
          searchLookupResult.message || recordsCommonAPIErrorT('notLookupField')
        )
        break

      default:
        throw new Error(`__typename: Invalid SearchLookup Response type`)
    }

    return searchLookupEmptyData
  }

  return { handleAPIResponse }
}

export default useAPIResponseHandler
